import {useMemo} from 'react'
import {AnalyticsProvider} from '@github-ui/analytics-provider'
import {Outlet} from '@github-ui/react-router'
import {useSearchBarEvents} from './hooks/use-search-bar-events'

export function App() {
  useSearchBarEvents()

  const metadata = useMemo(() => ({}), [])
  return (
    <AnalyticsProvider appName={'blackbird'} category={''} metadata={metadata}>
      <Outlet />
    </AnalyticsProvider>
  )
}
